<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-chip-group
      v-bind="schema.attributes"
      :class="schema.styleClasses"
    >
      <i4pro-chip 
        v-for="(chip, index) in schema.items"
        :key="index"
        :schema="chip" 
      />
    </v-chip-group>
  </div>
</template>
<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  components: {
    i4proChip: () => import('@/components/buttons/i4pro-chip')
  },

  props: {
    schema: { type: Object, default: () => ({}) }
  },

  mixins: [abstractField, devComponentMixin],
  methods: {
    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  }
};
</script>